
import React from 'react';
import { Helmet } from 'react-helmet-async';
import SurveyForm from '@/components/survey/SurveyForm';
import SEOMetadata from '@/components/common/SEOMetadata';

const Survey = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <SEOMetadata
        title="Tour Feedback Survey | Cats About Town Tours"
        description="Thank you for taking the time to provide feedback about your tour experience."
        noindex={true}
        canonicalUrl="https://catsabouttowntours.com/survey"
      />
      
      <div className="max-w-3xl mx-auto mb-8 text-center">
        <h1 className="text-3xl md:text-4xl font-montserrat font-bold mb-4">Tour Feedback Survey</h1>
        <p className="text-lg mb-6">
          Thank you for taking the time to provide feedback about your tour experience. 
          Your insights help us improve our tours for future guests.
        </p>
      </div>
      
      <SurveyForm />
    </div>
  );
};

export default Survey;
